
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/guides/[categorySlug]",
      function () {
        return require("private-next-pages/support/guides/[categorySlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/guides/[categorySlug]"])
      });
    }
  